import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "./api";

// Public, cached book-extras (feature flags, trail-map note, approved plain-words, published social prompts).
export function useBookExtras() {
  const [extras, setExtras] = useState({
    flags: { trail_map: true, plain_words: false, bring_to_session: false, social_circles_drafts: false },
    trail_map_note: "",
    plain_words: [],
    social_waypoints: [],
  });
  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/book-extras`).then(({ data }) => { if (!cancelled) setExtras(data); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return extras;
}
